import { AlertTriangle, Loader2 } from "lucide-react";
import { ROLE_WORDS } from "@/lib/numberWords";

// THE GENTLE AI NUDGE (his call, 21 Oct): when the AI CLEARLY called a number something else than where he put it,
// one amber line says so, with a one-tap Switch and Keep mine. No pop-up, nothing blocked, Undo untouched.
// "Clearly" = the AI marked it as the tag's part number, or labelled it with high/medium confidence. A label of
// "other" is no claim at all, so it never nudges.
const CLASS_OF_ROLE = { service_part: "part", serial: "serial" };
export const classOfRole = (role) => CLASS_OF_ROLE[role] || role || null;

export function aiClassOf(meta, inComponent) {
  if (!meta) return null;
  if (inComponent && meta.suggested_primary) return "part";
  if (!meta.label || !["high", "med", "medium"].includes(String(meta.label_confidence || "").toLowerCase())) return null;
  const c = classOfRole(meta.label);
  return c === "other" ? null : c;
}

export const classWords = (c) => (c === "part" ? "part number" : ROLE_WORDS[c] || String(c).replace("_", " "));

export function AiNudgeLine({ aiClass, primary, onSwitch, onKeep, busy, testid }) {
  const what = aiClass === "part" && primary ? "this tag's part number" : `a ${classWords(aiClass)}`;
  return (
    <div data-testid={testid} className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-amber-300 bg-amber-50 px-2.5 py-1.5 text-[12px] text-amber-900">
      <span className="inline-flex items-center gap-1"><AlertTriangle className="w-3.5 h-3.5 shrink-0" />The AI thought this was {what}.</span>
      <button type="button" data-testid={`${testid}-switch`} disabled={busy} onClick={onSwitch}
        className="font-bold underline underline-offset-2 disabled:opacity-50">
        {busy ? <Loader2 className="inline w-3 h-3 animate-spin" /> : `Switch to ${classWords(aiClass)}`}
      </button>
      <button type="button" data-testid={`${testid}-keep`} disabled={busy} onClick={onKeep}
        className="font-bold underline underline-offset-2 disabled:opacity-50">Keep mine</button>
    </div>
  );
}
